<template>
    <div>
        <header class="mint-header" @click="$router.go(-1)">
            <div class="mint-header-button is-left">
                <a class="router-link-exact-active router-link-active">
                    <button class="mint-button mint-button--default mint-button--normal">
                        <span class="mint-button-icon"><i class="mintui mintui-back"></i></span> 
                        <label class="mint-button-text">返回</label>
                    </button>
                </a>
            </div> 
        </header>
        <div class='me_wallet'>
            <div class='wallet-t'>
                <div class='t-til'>我的余额(元)</div>
                <div class='t-money'>{{price_num.toString().indexOf('.')>=0 ? price_num : `${price_num}.00`}}</div>
                <div class='t-pernum'>
                    <span>邀请下线 <span style='color: #fff'>{{succ_person}}</span> 人</span>
                    <span style='padding-left: 20px;'>累计激活 <span style='color: #fff'>{{jihuo_person}}</span> 套</span>
                </div>
            </div>
            <div class='wallet-b'>
                <div class='b1' @click="go_InviteList(1)">
                    <div>
                        <img src='../../assets/img/money_log.png' style='height: 26px;width: 26px'/>
                        <span style='padding-left: 5px;'>邀请记录</span>
                    </div>
                </div>
                <div class='b2' @click="go_InviteList(2)">
                    <div>
                        <img src='../../assets/img/money_img.png' style='height: 28px;width: 28px'/>
                        <span style='padding-left: 5px;'>提现</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            price_num: 0,
            succ_person: 0,
            jihuo_person: 0
        }
    },
    methods: {
        // 邀请记录
        go_InviteList(e) {
            let _this = this;
            if(e == 1) {
                this.$router.push({
                    path: '/agent/xiaxianlist'
                })
            }else{
                if(_this.price_num == 0){
                    _this.$messagebox({
                        title: '温馨提示',
                        message: "没钱不能提现",
                        showCancelButton: false,
                        confirmButtonText:"确定"
                    }).then(action => {
                        if(action == 'confirm'){
                            
                        }
                    })
                }else{
                    _this.$messagebox({
                        title: '温馨提示',
                        message: "提现请联系客服400-850-7088 (9:00-17:00)",
                        showCancelButton: false,
                        confirmButtonText:"确定"
                    }).then(action => {
                        if(action == 'confirm'){
                            
                        }
                    })
                }
            }
        }
    },
    mounted() {
        let _this = this;
        try {
            _this.$indicator.open('加载中...');
            _this.abp.api.AgentWallet()
                .then((res)=>{
                    _this.$indicator.close();
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            _this.price_num = res.data.Data.Price;
                            _this.succ_person = res.data.Data.AgentAmount;
                            _this.jihuo_person = res.data.Data.AgentSalesAmount;
                        }else{
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    _this.$indicator.close();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        } catch (error) {
            _this.$indicator.close();
        }
    }
}
</script>

<style>
    .me_wallet {
        width: 100%;
        /* position: absolute; */
        top: 0;
        height: 190px;
        line-height: 40px;
        font-size: 14px;
        background-color: #26a2ff;
    }
    .me_wallet .wallet-t {
        height: 140px;
        border-bottom: 1px solid #33adf0;
    }
    .me_wallet .wallet-t>.t-til {
        font-size: 11px;
        text-align: center;
        color: #fff;
        padding-top: 10px;
        height: 25px;
    }
    .me_wallet .wallet-t>.t-money {
        font-size: 32px;
        text-align: center;
        color: #fffeef;
        padding-top: 5px;
    }
    .me_wallet .wallet-t>.t-pernum {
        font-size: 13px;
        text-align: center;
        color: #b0e9ff;
        margin-top: 2px;
    }
    .me_wallet .wallet-b {
        height: 50px;
        display: flex;
        align-items: center;
    }
    .me_wallet .wallet-b>.b1,
    .me_wallet .wallet-b>.b2 {
        flex: 1;
        display: flex;
        justify-content: center;
        color: #fffeef;
        font-size: 15px;
    }
    .me_wallet .wallet-b>.b1 {
        border-right: 1px solid #33adf0;
    }
    .me_wallet .wallet-b>.b1>div,
    .me_wallet .wallet-b>.b2>div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
